import axios from '../http'

function query(data) {
    return axios.post('/event/matchMap/query', data);
}


function get(id) {
    return axios.get('/event/matchMap/get?id=' + id);
}

export default {
    query,
    get
}